
import { zuul } from '@/utils/global'

export default {
  method: 'get',
  // 基础url前缀
  baseUrl: zuul,
  // 请求头信息
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  formHeaders:{
   'Content-Type': 'application/x-www-form-urlencoded'
  },
  // 参数
  data: {},
  // 设置超时时间
//   timeout: 60000,
  timeout: 180000,
  // 携带凭证
  withCredentials: false,
  // 返回数据类型
  responseType: 'json'
}



// WEBPACK FOOTER //
// ./src/http/config.js